<template>
    <section>
        <PageTitle title="All Users" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/users',title:'users'}]" />
        <div class="wrapper wrapper-content animated fadeInRight">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ibox-title">
                        <h5 class="pull-left">All Users</h5>
                        <a v-on:click="loadNewUserModal()" class="pull-right" >Add New User</a>
                    </div>
                    <div class="ibox-content">
                      <form>
                        <div class="row">
                          <div class="col-md-3 form-group">
                            <search-customer-by-name-and-contact-number
                                ref="searchCustomerComponent"
                                :bayked-orders="true"
                                :get-users="true"
                                :is-deleted=customerDeleted
                                @selectedCustomer="(event) => this.selectedCustomerId = (event != null) ? event.id : null"
                            />
                          </div>
                          <div class="col-md-3 form-group h-90">
                            <label>Email</label>
                            <input placeholder="Enter Customer Email" id="email" class="form-control custom_width" type="email" />
                          </div>
                          <div style="height: 90px" class="col-md-3">
                            <label>Warehouses</label>
                            <Multiselect id="filter1"
                                         v-model="selectedRestaurant"
                                         :options="allRestaurants"
                                         :allow-empty="false"
                                         label="name"
                                         track-by="name"></Multiselect>
                          </div>
                          <div style="height: 90px" class="col-md-3">
                            <label>Vendors <b v-if="!selectedRestaurant" class="text-danger text-sm">(select warehouse)</b></label>
                            <Multiselect id="filter2"
                                         v-model="selectedBranch"
                                         :options="allBranches"
                                         label="name"
                                         track-by="name"
                                         :disabled="!selectedRestaurant"
                                         placeholder="Select Vendor"></Multiselect>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3 form-group h-90">
                            <label>Enabled</label>
                            <select id="enabled" class="form-control custom_width">
                              <option value="">All</option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </select>
                          </div>
                          <div class="col-md-3 form-group h-90">
                            <label>Role</label>
                            <select id="role" class="form-control custom_width">
                              <option value="">ALL</option>
                              <option value="ROLE_ADMIN">ADMIN</option>
                              <option value="ROLE_USER">USER</option>
                              <option value="ROLE_AGENT">AGENT</option>
                              <option value="ROLE_BRANCH">Vendor</option>
                              <option value="ROLE_CUSTOMER">CUSTOMER</option>
                              <option value="ROLE_RIDER">RIDER</option>
                            </select>
                          </div>
                          <div class="col-md-3 h-90">
                            <button  type="button" style="margin-top: 25px;margin-right: 10px" class=" btn btn-primary btn-sm search_btn"><i class="fa fa-search"></i> Search</button>
                            <button style="margin-top: 25px" class=" btn btn-info btn-sm refresh_btn"><i class="fa fa-refresh"></i> Refresh</button>
                          </div>
                        </div>
                      </form>
                      <hr />
                        <div class="table-responsive">
                            <table class="table table-striped table-responsive table-bordered table-hover" id="dtTable">
                                <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Contact</th>
                                    <th>Username</th>
                                    <th>Email</th>
                                    <th>Created</th>
                                    <th>Modified</th>
                                    <th>Enabled</th>
                                    <th>Role</th>
                                    <th class="text-center"><i class="fa fa-bolt"></i></th>
                                    <th class="text-center"><i class="fa fa-user-times"></i></th>
                                </tr>
                                </thead>
                                <tbody></tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <UpdateUsers ref="updateUserPopUp"/>
        <UpdateUsersPassword ref="updateUserPasswordPopUp"/>
    </section>
</template>

<script>
    /* eslint-disable */
    import PageTitle from '@/components/layout_components/PageTitle'
    import UpdateUsers from '@/components/users/UpdateUsers'
    import UpdateUsersPassword from '@/components/users/UpdateUsersPassword'
    import SearchCustomerByNameAndContactNumber from "@/components/utils/SearchCustomerByNameAndContactNumber";
    import {getAllBranchesOfRestaurant, getAllRestaurant} from "@/api/restaurants";
    import Multiselect from 'vue-multiselect';

    export default {
      name: "Users",
      components: {
        PageTitle,
        UpdateUsers,
        UpdateUsersPassword,
        SearchCustomerByNameAndContactNumber,
        Multiselect
      },
      data: function () {
        return {
          dtTable: null,
          customerDeleted: "No",
          selectedCustomerId: "",
          selectedRestaurant: null,
          allRestaurants: [],
          allBranchesObject: [],
          selectedBranch: null,
        };
      },
      created: function () {
        let loggedInUserRole = this.$store.state.user.userRolesById[0].role.split('_')[1];
        if (loggedInUserRole === 'AGENT') {
          this.$router.replace("/orders");
        }
      },
      mounted: async function () {
        await this.fetchRestaurantsAndBranches();
        await this.initializeDataTable();
        await this.jQueryOnRefreshAndSearchBtn();

      },
      computed: {
        allBranches() {
          return this.allBranchesObject.map((item) => {
            return {
              "id": item.id,
              "name": item.areasByAreaId.name,
            };
          })
        }
      },
      watch: {
        selectedRestaurant: async function () {
          if (this.selectedRestaurant !== null) {
            let params = new URLSearchParams();
            params.append("restaurant_id", this.selectedRestaurant.id);
            let restaurantBranches = await getAllBranchesOfRestaurant(params);
            this.allBranchesObject = restaurantBranches.data;
            this.selectedBranch = null;
          }
        }
      },
      methods: {
        initializeDataTable() {
          let self = this;
          let processingURL = this.$store.state.mainAppURL + "users/get_all_users";
          self.dtTable = $('#dtTable').DataTable({
            "processing": true,
            "serverSide": true,
            "autoWidth": false,
            "pageLength": 10,
            "dom": 'ltipr',
            'language': {
              //'loadingRecords': 'Please wait - loading...',
              'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
                  '                <div class="sk-double-bounce1"></div>\n' +
                  '                <div class="sk-double-bounce2"></div>\n' +
                  '              </div>'
            },
            "order": [[0, "desc"]],
            "ajax": {
              url: processingURL,
              type: "post",
              data: function (d) {
                return JSON.stringify(d);
              },
              headers: {
                "Content-type": "application/json; charset=utf-8"
              },
              beforeSend: (xhr) => {
                xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
              },
              statusCode: {
                401: () => {
                  this.updateRefreshTokenInDataTable(this.dtTable);
                }
              }
            },
            "columnDefs": [
              {"orderable": false, "targets": [1, 2, 3, 4, 5, 8, 9, 10]},
              {'className': "text-center", 'aTargets': [0, 3, 4, 5, 6, 7, 8, 9, 10]},
            ],
            "columns": [
              {"data": "id", "name": "id"},
              {"data": "fullName", "name": "fullName"},
              {"data": "contact", "name": "contact"},
              {"data": "username", "name": "username"},
              {"data": "email", "name": "email"},
              {
                "data": "created",
                "name": "created",
                "render": function (data) {
                  return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
                }
              },
              {
                "data": "modified",
                "name": "modified",
                "render": function (data) {
                  return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
                }
              },
              {
                "data": "enabled", "name": "enabled",
                render: function (data) {
                  if (data) {
                    return "<label class='label label-success'>Yes</label>"
                  } else {
                    return "<label class='label label-danger'>No</label>"
                  }
                }
              },
              {"data": "role", "name": "role"},
              {
                "data": "action", "name": "action",
                render: function (data, type, row) {
                  return "<a data-id='" + row.id + "' class='updateUserBtn'>Update</a>" +
                      "|<a data-id='" + row.id + "' class='updateUserPassword'>Update Password</a>";
                }
              },
              {
                "data": "delete", "name": "delete",
                render: function (data, type, row) {
                  return "<a data-id='" + row.id + "' class='deleteUser'><i class='fa fa-trash'></i></a>"
                }
              }
            ],
            "drawCallback": function (settings) {
              $(".m_tip").tooltip();
              $(".updateUserBtn").click(function () {
                self.$refs.updateUserPopUp.load($(this).attr("data-id"));
              });
              $(".updateUserPassword").click(function () {
                self.$refs.updateUserPasswordPopUp.load($(this).attr("data-id"));
              });
              $(".deleteUser").click(function () {
                let userId = $(this).attr("data-id");
                Swal({
                  title: 'Are you sure?',
                  text: "Are you sure you want to delete this user!",
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#1ab394',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                  if (result.value) {
                    self.showLoading();
                    self.$http.delete(self.$store.state.mainAppURL + "users/" + userId).then(resp => {
                      if (resp.data) {
                        self.dtTable.ajax.reload(null, false);
                        swal("SUCCESS!", "User has been deleted successfully!", "success");
                      } else {
                        swal("Error!", "Please try again!", "error");
                      }
                    }).catch(ex => {
                      this.showErrorMessage(ex);
                    });
                  }
                });
              })
            }
          });
          $.fn.dataTable.ext.errMode = 'none';
          let dtTableFilterSelector = $("#dtTable_filter input");
          dtTableFilterSelector.unbind();
          dtTableFilterSelector.attr("size", "35");
          dtTableFilterSelector.attr("placeholder", "Search on name , contact or username....");
          dtTableFilterSelector.keyup(function (e) {
            if (e.keyCode === 13) {
              self.dtTable.search($(this).val()).draw();
            }
          });
        },
        loadNewUserModal: function () {
          this.$refs.updateUserPopUp.load(0);
        },
        async fetchRestaurantsAndBranches() {
          this.loggedInRole = this.$store.getters.user.userRolesById[0].role;
          if (this.loggedInRole === 'ROLE_USER') {
            let user_restaurant = this.$store.getters.user.restaurant;
            this.selectedRestaurant = user_restaurant;
            let params = new URLSearchParams();
            params.append("restaurant_id", user_restaurant.id);
            let resp = await getAllBranchesOfRestaurant(params);
            this.allBranchesObject = resp.data;
          } else {
            let resp = await getAllRestaurant();
            this.allRestaurants = resp.data;
          }
        },
        jQueryOnRefreshAndSearchBtn() {

          let self = this;
          $(".search_btn").click(function () {
            self.resetData();
            var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
            if ($("#email").val() && !emailReg.test($("#email").val())) {
              return;
            }
            if (self.selectedCustomerId) {
              self.dtTable.column(0).search(self.selectedCustomerId);
            }
            if (self.selectedRestaurant !== null) {
              self.dtTable.column(1).search(self.selectedRestaurant.id);
            }
            if (self.selectedBranch !== null) {
              self.dtTable.column(2).search(self.selectedBranch.id);
            }
            self.dtTable.column(4).search($("#email").val());
            self.dtTable.column(7).search($("#enabled").val());
            self.dtTable.column(8).search($("#role").val());
            self.dtTable.draw();
          });
          $(".refresh_btn").click(function () {
            $("#email").val('');
            $("#enabled").val('');
            $("#role").val('');
            self.resetData();
            self.selectedBranch = null;
            if (self.loggedInRole !== 'ROLE_USER') {
              self.selectedRestaurant = null;
              self.allBranchesObject = [];
            }
            self.$refs.searchCustomerComponent.selectedCustomerTemp = ""
            self.selectedCustomer = ""
            self.dtTable.draw();
          });
        },
        resetData() {
          let self = this;
          self.dtTable.column(0).search('');
          self.dtTable.column(1).search('');
          self.dtTable.column(2).search('');
          self.dtTable.column(4).search('');
          self.dtTable.column(7).search('');
          self.dtTable.column(8).search('');
        }
      }
    }
</script>

<style scoped>

</style>
